import { render, staticRenderFns } from "./wholeForm.vue?vue&type=template&id=59781004&scoped=true&"
import script from "./wholeForm.vue?vue&type=script&lang=js&"
export * from "./wholeForm.vue?vue&type=script&lang=js&"
import style0 from "./wholeForm.vue?vue&type=style&index=0&id=59781004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59781004",
  null
  
)

export default component.exports